import React from "react";
import styles from "./landing.module.css";
import Icon from "../../components/icons/icons";
import PubHeader from "../../components/header/pub/header";
import bankList from './bankList';

class StartPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skin: localStorage.getItem('faktura-skin'),
      bankName: '',
      bankApp: '',
      bankLink: ''
    }
  }

  componentDidMount() {
    let bank = this.props.match.params.bank;
    localStorage.setItem("faktura-skin", bank);
    const localSkin = bank + '.css';
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = 'https://elf.faktura.ru/elf/skins/' + bank + '/favicon.ico';
    document.getElementsByTagName('head')[0].appendChild(link);
    const skinUrl = process.env.PUBLIC_URL + '/skins/' + localSkin;
    document.head.innerHTML += `<link type="text/css" rel="stylesheet" href=${skinUrl}>`;
    let getBankList = (item) => {
      if(item.label === bank) {
        this.setState({
          bankName: item.value,
          bankApp: item.app,
          bankLink: item.link
        })
      }
    }
    bankList.map(getBankList);
  }

  prevSlide = () => {
    let sliderItems = document.getElementById("slider-items");
    let activeSlide = sliderItems.querySelector("[data-active]");
    let lastSlide = sliderItems.lastChild;
    let prevSlide = activeSlide.previousSibling;
    activeSlide.removeAttribute("data-active");
    if (prevSlide) {
      prevSlide.setAttribute("data-active", "");
    } else {
      lastSlide.setAttribute("data-active", "");
    }
  };

  nextSlide = () => {
    let sliderItems = document.getElementById("slider-items");
    let activeSlide = sliderItems.querySelector("[data-active]");
    let firstSlide = sliderItems.querySelector("div");
    let nextSlide = activeSlide.nextSibling;
    activeSlide.removeAttribute("data-active");
    if (nextSlide) {
      nextSlide.setAttribute("data-active", "");
    } else {
      firstSlide.setAttribute("data-active", "");
    }
  };

  focusBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth"
    });
  };

  render() {
    document.querySelector('body').setAttribute('style', 'background:#fff')
    return (
      <main>
        <PubHeader/>
        <div className={styles.landing}>
          <div className={styles.landing__slider}>
            <div id="slider-items">
              <div className={styles.landing__slider_item} data-active>
                <div className={styles.landing__slider_info}>
                  <div className={styles.landing__slider_title}>
                    Стать самозанятым <span onClick={this.focusBottom} style={{cursor: 'pointer'}}>*</span><br />
                    с банком {this.state.bankName}
                  </div>
                  <div>
                    Станьте клиентом банка, принимайте оплату от клиентов и оплачивайте налог онлайн.
                  </div>
                  <a className={styles.landing__button} href={this.state.bankLink}>Стать клиентом</a>
                </div>
              </div>
              <div className={styles.landing__slider_item}>
                <div className={styles.landing__slider_info}>
                  <div className={styles.landing__slider_title}>
                    Стать самозанятым <span onClick={this.focusBottom} style={{cursor: 'pointer'}}>*</span><br />
                    с банком {this.state.bankName}
                  </div>
                  <div>
                    Станьте клиентом банка, принимайте оплату от клиентов и оплачивайте налог онлайн.
                  </div>
                  <a className={styles.landing__button} href={this.state.bankLink}>Стать клиентом</a>
                </div>
              </div>
            </div>
            <div className={styles.landing__prev} id="slider-prev" onClick={this.prevSlide}>
              <Icon name="icon_arrow" viewbox="0 0 32 32"/>
            </div>
            <div className={styles.landing__next} id="slider-next" onClick={this.nextSlide}>
              <Icon name="icon_arrow" viewbox="0 0 32 32"/>
            </div>
          </div>
          <div className="inner">
            <div className="l-align_center">
              <div className={styles.landing__title}>Преимущества для вас</div>
            </div>
            <div className="clear">
              {(this.state.skin === 'siab' || this.state.skin === 'united') ? null : <div className={styles.landing__odds}>
                <Icon name="icon_landing01" viewbox="0 0 120 120"/>
                Автоматическая регистрация<br/>доходов от постоянных<br/>клиентов
              </div>}
              <div className={styles.landing__odds} style={{width: (this.state.skin === 'siab' || this.state.skin === 'united') ? '33%' : '25%'}}>
                <Icon name="icon_landing02" viewbox="0 0 120 120"/>
                Оплата налога<br/>
                онлайн
              </div>
              <div className={styles.landing__odds} style={{width: (this.state.skin === 'siab' || this.state.skin === 'united') ? '33%' : '25%'}}>
                {
                  this.state.skin === 'vesta' ?
                    <React.Fragment>
                      <Icon name="icon_landing03" viewbox="0 0 120 120"/>
                      5% на остаток по карте<br/>
                      с тарифом «Самозанятый»
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <Icon name="icon_landing03_2" viewbox="0 0 120 120"/>
                      Предоставление чеков <br/>клиентам
                    </React.Fragment>
                }
              </div>
              <div className={styles.landing__odds} style={{width: (this.state.skin === 'siab' || this.state.skin === 'united') ? '33%' : '25%'}}>
                <Icon name="icon_landing04" viewbox="0 0 120 120"/>
                Удобный интерфейс для<br/>контроля расходов
              </div>
            </div>
            <div className='l-align_center'>
              <React.Fragment>
                <div className={styles.landing__title}>
                  Как стать клиентом Банка «{this.state.bankName}»
                </div>
                <div className='l-grid_pt-6'>
                  <div className='l-grid__item_2'>
                    <div className={styles.regStep}>1</div>
                    <div className={styles.regText}>
                      Заказать дебетовую карту <br/>и открыть счет в любом <br/>офисе банка
                    </div>
                  </div>
                  <div className='l-grid__item_2'>
                    <div className={styles.regStep}>2</div>
                    <div className={styles.regText}>
                      Получить карту с паспортом в офисе банка: мы сообщим о ее готовности по телефону или в
                      sms-сообщении
                    </div>
                  </div>
                  <div className='l-grid__item_2'>
                    <div className={styles.regStep}>3</div>
                    <div className={styles.regText}>
                      Установить приложение {this.state.bankApp} для управления собственными средствами со смартфона в
                      режиме 24/7
                    </div>
                  </div>
                </div>
                {/*<div className={styles.regText} style={{marginBottom: '120px'}}>*/}
                {/*  Подходит тем, кто уже зарегистрирован как самозанятый в ФНС и тем кто хочет стать клиентом*/}
                {/*  банка<br/>*/}
                {/*  <a className={styles.landing__button} target="_blank" rel="noopener noreferrer"*/}
                {/*     href={this.state.bankLink}>Стать клиентом</a>*/}
                {/*</div>*/}
              </React.Fragment>
            </div>
          </div>
          <div className={styles.landing__wrapper}>
            <div className={styles.landing__cheque}/>
            <div className="inner">
              <div className={styles.landing__inner}>
                <div className={styles.landing__title}>
                  Доверие к вам
                </div>
                <ul className={styles.landing__list}>
                  <li>
                    <div className={styles.landing__list_infotitle}>Формируйте электронные чеки</div>
                    <div className={styles.landing__list_info}>
                      при получении платежей от клиентов и укрепите их доверие к вам
                    </div>
                  </li>
                  {(this.state.skin === 'siab' || this.state.skin === 'united') ? null : <li>
                    <div className={styles.landing__list_infotitle}>Ведите каталог постоянных клиентов</div>
                    <div className={styles.landing__list_info}>
                      с возможностью формировать чеки автоматически
                    </div>
                  </li>}
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.landing__footer} style={{paddingTop: (this.state.skin === 'siab' || this.state.skin === 'united') ? '22rem' : '16.3125rem'}}>
            <div className="inner">
              <div className={styles.landing__footer_title}>
                Налоги
              </div>
              <div className="l-grid">
                <div className="l-grid__item_3">
                  <div className={styles.landing__footer_white}>
                    <div>4 %</div>
                    если работаете<br/>
                    с физическими<br/>
                    лицами
                    <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                  </div>
                </div>
                <div className="l-grid__item_3">
                  <div className={styles.landing__footer_white}>
                    <div>6 %</div>
                    если работаете<br/>
                    с юридическими<br/>
                    лицами
                    <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                  </div>
                </div>
                <div className="l-grid__item_6">
                  <div className={styles.landing__footer_black}>
                    <div>налоговый вычет</div>
                    10 000 рублей<br/>
                    и снижение ставки
                    <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                  </div>
                </div>
              </div>
              <div className="l-grid">
                <div className="l-grid__item_6">
                  <div className={styles.landing__footer_red}>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Не нужно платить <br/>страховые взносы
                    </div>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Без отчетности и <br/>деклараций
                    </div>
                  </div>
                </div>
                <div className="l-grid__item_6">
                  <div className={styles.landing__footer_blue}>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Рассчитываются <br/>автоматически
                    </div>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Уплачиваются раз в месяц
                    </div>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Ставка налога не изменится<br/>
                      до 2029 года
                    </div>
                  </div>
                </div>
              </div>
              <div className="l-align_center">
                <a className={styles.landing__button} href={process.env.REACT_APP_ELF_URL}>Я уже клиент банка</a>
              </div>
              <div className="l-align_center" style={{marginTop: '10.625rem'}}>
                <div className={styles.footer_nskbl}>
                  <div className={styles.regText} style={{marginBottom: '120px'}}>
                    Вся подробная информация на сайте ФНС <a target="_blank" rel="noopener noreferrer"
                                                             href="https://npd.nalog.ru">npd.nalog.ru</a> в
                    разделе <a
                    target="_blank" rel="noopener noreferrer" href="https://npd.nalog.ru/faq/">Вопросы</a>
                  </div>
                  <div className={styles.footer__text}>
                    * Самозанятый – физическое лицо - налогоплательщик РФ, применяющий специальный налоговый
                    режим<br/>
                    «Налог на профессиональный доход» (в соответствии с 422-ФЗ).
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    )
  }
}

export default StartPage;
